import { IUserData } from "../../interfaces/user/IUserData";
import * as Sentry from "@sentry/nextjs";

type SetSentryUser = {
  user: IUserData;
};

export const setSentryUser = ({ user }: SetSentryUser) => {
  if (!user || !user.id || !user.name) return;

  Sentry.setUser({
    id: user.id,
    name: user.name,
  });
};

export const clearSentryUser = () => {
  Sentry.setUser(null);
};
